import React from 'react';

const RatesResultsSkeleton = () => {
  return (
    <div className="animate-pulse flex flex-col items-center justify-center space-y-4">
      <div className="grid md:grid-cols-2 gap-4 md:gap-5 lg:gap-8 w-full">
        {Array(4).fill().map((_, index) => (
          <div
            key={index}
            className="bg-gray-100 px-8 py-4 border border-gray-300 rounded-lg shadow-sm flex items-center"
          >
            <div className="flex-grow space-y-3">
              <div className="bg-gray-300 h-6 w-3/4 rounded-md"></div>
              <div className="bg-gray-300 h-[18px] w-1/2 rounded-md"></div>
              <div className="bg-gray-300 h-4 w-1/4 rounded-md"></div>
            </div>
            <div className="
              flex-shrink-0 ml-4 flex items-center justify-center h-16 w-16 rounded-full bg-white border border-gray-100
            ">
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RatesResultsSkeleton;
